import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = 'site_settings';

// قيم احتياطية لحد ما الإعدادات توصل من السيرفر (أول زيارة بس — بعدها من الكاش)
const DEFAULTS = {
  site_name: 'وهيبة فاشن',
  description: 'متجر إلكتروني للملابس النسائية العصرية والأنيقة بأعلى معايير الجودة والأناقة.',
  logo_url: null,
  phone: null,
  whatsapp_number: null,
  whatsapp_url: null,
  instagram: null,
  facebook: null,
};

const readCache = () => {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY)) || null;
  } catch {
    return null;
  }
};

const SettingsContext = createContext(DEFAULTS);

/** إعدادات الموقع من لوحة التحكم (الاسم، الشعار، الهاتف، السوشيال). */
export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => ({ ...DEFAULTS, ...readCache() }));

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((res) => {
        const data = res.data?.data;
        if (!data) return;
        setSettings({ ...DEFAULTS, ...data });
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {
          /* التخزين غير متاح */
        }
      })
      .catch((err) => console.error('Failed to fetch settings:', err));
  }, []);

  // اسم الموقع في عنوان التاب
  useEffect(() => {
    if (settings.site_name) document.title = settings.site_name;
  }, [settings.site_name]);

  // أيقونة التاب (favicon) = شعار الموقع من الإعدادات؛ لو مفيش شعار بتفضل الأيقونة الافتراضية
  useEffect(() => {
    if (!settings.logo_url) return;
    const icon = document.querySelector('link[rel="icon"]') || document.head.appendChild(Object.assign(document.createElement('link'), { rel: 'icon' }));
    icon.removeAttribute('type');
    icon.href = settings.logo_url;
    const touch = document.querySelector('link[rel="apple-touch-icon"]');
    if (touch) touch.href = settings.logo_url;
  }, [settings.logo_url]);

  const value = useMemo(
    () => ({
      ...settings,
      // رقم الهاتف كما أدخله الأدمن (للعرض)
      whatsapp_display: settings.phone,
      // رابط اتصال مباشر بالصيغة الدولية (tel:+962...) عشان يشتغل من أي موبايل
      tel_url: settings.whatsapp_number ? `tel:+${settings.whatsapp_number}` : null,
    }),
    [settings]
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
